<template>
  <a
    class="button-text-link"
    :class="[styleClassName, sizeClassName]"
    :href="href"
    :download="download"
  >
    <span class="button-text-link__text">{{ text }}</span>
  </a>
</template>

<script>
import sizes from '@/constants/ui-kit/standard/sizes'
import styles from '@/constants/ui-kit/standard/styles'

export default {
  name: 'AppButtonTextLink',
  props: {
    text: {
      type: String,
      required: true,
    },
    buttonStyle: {
      type: String,
      default: styles.PRIMARY,
      validator: (value) => Object.values(styles).includes(value),
    },
    size: {
      type: String,
      default: sizes.SM,
      validator: (value) => Object.values(sizes).includes(value),
    },
    href: {
      type: String,
      required: true,
    },
    download: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    styleClassName() {
      return `button-text-link--${this.buttonStyle}`
    },
    sizeClassName() {
      return `button-text-link--${this.size}`
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'app-button.mixin';
.button-text-link {
  @include button-styles;
  @include button-text-sizes;
  @include button-alternatives;
  @include noselect;
}
</style>
